<template>
  <div>
    <b-card>
      <b-overlay :show="isLoading" rounded="sm">
        <h4 class="font-weight-bold mb-4">
          {{ isEdit ? "編輯聯絡人" : "新增聯絡人" }}
        </h4>

        <b-form-group
          label-cols="12"
          label-cols-lg="2"
          content-cols="12"
          content-cols-lg="6"
          label="聯絡人姓名"
        >
          <b-form-input
            v-model="contact.name"
            :state="nameState"
          ></b-form-input>
          <b-form-invalid-feedback :state="nameState">
            請輸入聯絡人姓名
          </b-form-invalid-feedback>
        </b-form-group>

        <b-form-group
          label-cols="12"
          label-cols-lg="2"
          content-cols="12"
          content-cols-lg="6"
          label="關係"
        >
          <b-form-input v-model="contact.relationship"></b-form-input>
        </b-form-group>

        <b-form-group
          label-cols="12"
          label-cols-lg="2"
          content-cols="12"
          content-cols-lg="6"
          label="手機號碼"
        >
          <b-form-input v-model="contact.mobile_phone"></b-form-input>
        </b-form-group>

        <b-form-group
          label-cols="12"
          label-cols-lg="2"
          content-cols="12"
          content-cols-lg="6"
          label="生日"
        >
          <datepicker
            placeholder="選擇日期"
            v-model="birthday"
            bootstrap-styling
            format="yyyy-MM-dd"
            :language="zh"
            clear-button
          ></datepicker>
        </b-form-group>

        <b-form-group
          label-cols="12"
          label-cols-lg="2"
          content-cols="12"
          content-cols-lg="6"
          label="性別"
        >
          <b-form-radio-group
            v-model="contact.sexual"
            :options="sexualOptions"
            value-field="value"
            text-field="text"
          ></b-form-radio-group>
        </b-form-group>

        <div class="d-flex justify-content-center mt-4">
          <b-button
            variant="outline-secondary"
            class="mr-2"
            :to="{ name: 'CustomerContactList', params: { customerID } }"
          >
            取消
          </b-button>
          <b-button variant="primary" :disabled="isLoading" @click="save">
            儲存
          </b-button>
        </div>
      </b-overlay>
    </b-card>
  </div>
</template>

<script>
import { format } from "date-fns";
import Datepicker from "vuejs-datepicker";
import { zh } from "vuejs-datepicker/dist/locale";
import contactApi from "@/apis/contact";

export default {
  components: { Datepicker },
  data() {
    return {
      zh,
      isLoading: false,
      submitted: false,
      birthday: null,
      contact: {
        name: "",
        relationship: "",
        mobile_phone: "",
        birthday: null,
        sexual: null,
      },
      sexualOptions: [
        { text: "男", value: "male" },
        { text: "女", value: "female" },
        { text: "未設定", value: null },
      ],
    };
  },
  computed: {
    customerID() {
      return this.$route.params.customerID;
    },
    contactID() {
      return this.$route.params.contactID;
    },
    isEdit() {
      return !!this.contactID;
    },
    nameState() {
      if (!this.submitted) return null;
      return !!this.contact.name;
    },
  },
  created() {
    if (this.isEdit) this.fetchContact();
  },
  methods: {
    async fetchContact() {
      try {
        this.isLoading = true;
        const { data } = await contactApi.get(this.contactID);
        this.contact = {
          name: data.data.name,
          relationship: data.data.relationship,
          mobile_phone: data.data.mobile_phone,
          birthday: data.data.birthday,
          sexual: data.data.sexual,
        };
        this.birthday = data.data.birthday ? new Date(data.data.birthday) : null;
      } catch (error) {
        console.log(error);
      } finally {
        this.isLoading = false;
      }
    },
    async save() {
      this.submitted = true;
      if (!this.contact.name) return;

      const payload = {
        name: this.contact.name,
        relationship: this.contact.relationship,
        mobile_phone: this.contact.mobile_phone,
        sexual: this.contact.sexual,
        birthday: this.birthday ? format(new Date(this.birthday), "yyyy-MM-dd") : null,
      };

      try {
        this.isLoading = true;
        if (this.isEdit) {
          await contactApi.update(this.contactID, payload);
        } else {
          await contactApi.store(this.customerID, payload);
        }
        this.$swal.fire({ type: "success", text: "儲存成功" });
        this.$router.push({ name: "CustomerContactList", params: { customerID: this.customerID } });
      } catch (error) {
        console.log(error);
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>
